import type { TextVariant } from './types'

export const textVariantsToBaseClasses: Record<
  TextVariant,
  { base: string; defaultColor: string }
> = {
  docTitle: {
    base: 'note-editor-title font-weight-semibold',
    defaultColor: '',
  },
  title: {
    base: 'font-size-largest font-family-system font-weight-bold',
    defaultColor: 'shade-05',
  },
  titleSmall: {
    base: 'font-size-large font-family-system font-weight-extrabold',
    defaultColor: 'shade-05',
  },
  subtitle: {
    base: 'font-size-larger font-family-system font-weight-extrabold',
    defaultColor: 'shade-05',
  },
  subtitleSmall: {
    base: 'font-size-large font-family-system line-height-larger',
    defaultColor: 'shade-05',
  },
  body: {
    base: 'font-size-large font-family-system line-height-larger',
    defaultColor: 'shade-10',
  },
  caption: {
    base: 'font-size-small font-family-system font-weight-regular',
    defaultColor: 'shade-20',
  },
  callout: {
    base: 'font-size-smaller font-family-system capitalise font-weight-extrabold uppercase letter-spacing-small',
    defaultColor: '',
  },
  action: {
    base: 'pointer font-size-normal font-family-system font-weight-semibold',
    defaultColor: 'shade-20 shade-05-on-hover',
  },
  primaryAction: {
    base: 'pointer font-size-normal font-family-system font-weight-semibold',
    defaultColor: 'primary primary-dark-on-hover',
  },
  link: {
    base: 'pointer underline font-family-system font-weight-semibold',
    defaultColor: 'shade-20',
  },
  formLabel: {
    base: 'font-size-large font-family-system font-weight-semibold line-height-large',
    defaultColor: 'shade-05',
  },
  label: {
    base: 'font-size-normal font-weight-semibold line-height-large',
    defaultColor: 'shade-05',
  },
}
